import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { CommonHttpService } from './http.service';

/**
 * Points program API (Engine backend). Account side reads the client summary
 * and paginated statement; checkout side reads redemption availability and
 * applies/removes points on the cart session (never debits — the debit happens
 * server-side when the order is registered).
 */
@Injectable()
export class PointsService {
    constructor(
        protected http: CommonHttpService
    ) {}

    /** Client summary: enabled gate, balance, currency equivalent, pending, expiring. */
    public summary(clientId: number): Observable<Response> {
        return this.http.useAuth().get(`account/clients/${+clientId}/points`);
    }

    /** Paginated statement (most recent first). */
    public statement(clientId: number, page: number, perPage: number = 10): Observable<Response> {
        return this.http.useAuth().get(
            `account/clients/${+clientId}/points/statement`
            + `?page=${+page}`
            + `&per_page=${+perPage}`
        );
    }

    /** Checkout: is redemption available, minimum, max redeemable and applied. */
    public availability(): Observable<Response> {
        return this.http.useAuth().get('/checkout/payment/resume/points');
    }

    /** Checkout: apply N points as a discount on the cart session. */
    public apply(points: number) {
        return new Observable(observable => {
            this.http.useAuth()
                .put('/checkout/payment/resume/apply-points', {'points': +points})
                .subscribe((res: Response) => {
                    observable.next(res.json().data);
                    observable.complete();
                }, (err: Response) => {
                    observable.error(err.json());
                });
        });
    }

    /** Checkout: remove the applied points from the cart session. */
    public reset() {
        return new Observable(observable => {
            this.http.useAuth()
                .put('/checkout/payment/resume/reset-points', {})
                .subscribe((res: Response) => {
                    observable.next(res.json().data);
                    observable.complete();
                }, (err: Response) => {
                    observable.error(err.json());
                });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/shared/services/points.service.ts